import Icon from '../Icon';
import {familyClasses, kindInfo} from '../../lib/kinds';
import {Kind} from '../../types';

// DESIGN.md §5: 26px pill, family bg/fg, 16px icon + kind name at 650. `md` is the 28px detail
// variant; `lg` the 36px tappable one in the step-3 header.
type Props = {kind: Kind; size?: 'sm' | 'md' | 'lg'; className?: string};

export default function KindPill({kind, size = 'sm', className = ''}: Props) {
    const info = kindInfo(kind);
    const dims = size === 'lg' ? 'h-9 pl-2 pr-3 text-[15px] font-bold' : size === 'md' ? 'h-7 pl-[6px] pr-[10px] text-xs font-bold' : 'h-[26px] pl-[6px] pr-[10px] text-xs font-[650]';
    return (
        <span className={`inline-flex items-center gap-[5px] rounded-pill ${dims} ${familyClasses(info.family)} ${className}`}>
            <Icon name={info.icon} size={size === 'lg' ? 20 : 16} strokeWidth={1.9} />
            {info.label}
        </span>
    );
}
